'use client';

import { getRibbonText, RibbonProduct, RibbonTypeEnum } from './productBannerHelpers';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';

export interface ProductBannerProps {
  product: RibbonProduct;
  renderEmpty?: boolean;
  outOfStockText?: string;
  saleText?: string;
  newText?: string;
  comingSoonText?: string;
  className?: string;
  vip?: boolean;
}

const ProductBanner = ({
  product,
  outOfStockText,
  saleText,
  newText,
  comingSoonText,
  renderEmpty = false,
  className,
  vip,
}: ProductBannerProps) => {
  const { t } = useTranslation();
  const _outOfStockText =
    outOfStockText ??
    t('productDetailPageContent.outOfStockText', undefined, { default: 'Out of Stock' });
  const _saleText =
    saleText ?? t('productDetailPageContent.saleText', undefined, { default: 'On Sale' });
  const _newText = newText ?? t('productDetailPageContent.newText', undefined, { default: 'New' });
  const _comingSoonText =
    comingSoonText ??
    t('productDetailPageContent.comingSoonText', undefined, { default: 'Coming Soon' });

  const RIBBON_STYLE = React.useMemo(
    () => ({
      [_outOfStockText || RibbonTypeEnum.OutOfStock]: 'bg-neutral-400',
      [_saleText || RibbonTypeEnum.Sale]: 'bg-brand-400',
      [RibbonTypeEnum.FreeBundle]: 'bg-warm-500',
      [_newText || RibbonTypeEnum.New]: 'bg-brand-400',
      [_comingSoonText || RibbonTypeEnum.ComingSoon]: 'bg-warm-500',
    }),
    [_newText, _outOfStockText, _saleText, _comingSoonText],
  );

  const ribbonText = getRibbonText(
    product,
    _newText,
    _saleText,
    _outOfStockText,
    _comingSoonText,
    vip,
  );

  if (!ribbonText && !renderEmpty) return null;

  return (
    <div
      className={classNames(
        'flex items-center px-6 relative py-2',
        ribbonText && RIBBON_STYLE[ribbonText],
        className,
      )}
      suppressHydrationWarning
    >
      <h6 className={classNames('tra-text-web-heading text-lg text-white mb-0 text-center')}>
        {ribbonText}
      </h6>
    </div>
  );
};

export default ProductBanner;
